
import clickOutside from '../../../directives/click-outside';
import Icon from 'JS/components/Icon.vue';
import menuManager from '../../util/menu-manager';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IManagedMenu } from '../../../types/Header';
import { setModalOpenClasses, unsetOpenClasses } from '../../util/menu.utils';

// https://www.smashingmagazine.com/2017/11/building-accessible-menu-systems/
@Component({
	name: 'HeaderDropMenu',
	components: {
		Icon
	},
	directives: {
		clickOutside
	}
})
export default class HeaderDropMenu extends Vue implements IManagedMenu {

	$refs!: {
		menuTrigger: HTMLElement;
		menuWrapper: HTMLElement;
	}

	/* Props
	============================================*/

	// https://github.com/vuejs/vue/issues/6144#issuecomment-316543936
	@Prop({ type: String, required: false, default: '' })
	readonly targetClass: string;

	@Prop({ type: String, required: false, default: 'right' })
	readonly position: string;

	@Prop({ type: String, required: true })
	readonly dropdownAriaLabel: string;

	/* Data
	============================================*/

	isShowing: boolean = false;
	hasBeenShown: boolean = false;

	/* Computed
	============================================*/

	get menuId(): string {
		return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
	}

	/* Methods
	============================================*/

	handleKeyPress(e: KeyboardEvent) {
		switch (e.key) {
			case 'Escape':
				this.hide();
				this.$refs.menuTrigger.focus();
				break;
			default:
				break;
		}
	}

	handleFocusOut(e: FocusEvent) {
		const nextFocused = e.relatedTarget;

		if (this.isShowing
			&& nextFocused
			&& !this.$refs.menuWrapper?.contains(nextFocused as Node)
		) {
			this.hide();
		}
	}

	show() {
		if (this.isShowing) return;
		menuManager.closeMenus();
		menuManager.addMenu(this as any);
		this.$emit('open');
		this.hasBeenShown = true;
		this.isShowing = true;

		//add shadowed2
		const content = document.getElementById('contentWrapper');
		if (!content) return;
		content.classList.add('shadowed');

		if (window.innerWidth > 767) return;
		setModalOpenClasses(true);
	}

	hide() {
		if (!this.isShowing) return;
		menuManager.removeMenu(this as any);
		this.isShowing = false;
		this.$emit('close');
		unsetOpenClasses();

		//remove shadowed
		const content = document.getElementById('contentWrapper');
		if (!content) return;
		content.classList.remove('shadowed');
	}

	toggle() {
		if (this.isShowing) {
			this.hide();
		} else {
			this.show();
		}
	}

	/* Lifecycle Hooks
	============================================*/

	destoyed() {
		menuManager.removeMenu(this);
	}

}

